module.exports = __webpack_public_path__ + "img/our-advantages-1.5aebd4aa.png";